// swiperInit.js
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.related-resources-section');
    const mobileBreakpoint = 767;

    sections.forEach(section => {
        const sliders = section.querySelectorAll('.rrs-card-slider');
        let swipers = [];

        const initSwiper = () => {
            sliders.forEach(slider => {
                if (!slider.swiper) {
                    const swiperInstance = new Swiper(slider, {
                        loop: false,
                        slidesPerView: 1.26,
                        allowTouchMove: true,
                        spaceBetween: 32,
                        navigation: {
                            prevEl: section.querySelector('.rrs-button-prev'),
                            nextEl: section.querySelector('.rrs-button-next'),
                        },
                        breakpoints: {
                            576: {
                                slidesPerView: 2,
                            },
                        },
                    });

                    swipers.push(swiperInstance);
                }
            });
        };

        const destroySwiper = () => {
            swipers.forEach(swiper => {
                if (swiper && !swiper.destroyed) {
                    swiper.destroy(true, true);
                }
            });
            swipers = [];
        };

        const handleResize = () => {
            if (window.innerWidth <= mobileBreakpoint) {
                initSwiper(); // 📱 Mobile → enable
            } else {
                destroySwiper(); // 🖥 Desktop → destroy
            }
        };

        // Initial check
        handleResize();

        // Listen for resize
        window.addEventListener('resize', handleResize);
    });
});